<template>
  <div id="bind-parent" v-if="showBindParent">
    <div class="bind-parent-content">
      <h1>请扫描二维码，完成注册激活学生账号</h1>
      <div class="qrCode" :class="{'loading':qrCodeLoading}">
        <img :src="qrCode" alt />
      </div>
    </div>
  </div>
</template>
<script>
import * as comApi from "@/api/commonApi";
export default {
  name: "bindParent",
  // mixins: [organization],
  data() {
    return {
      showBindParent: false,
      qrCode: null,
      qrCodeLoading: false,
      checkBindTimer: null
    };
  },
  watch: {
    $route(to, from) {
      this.jude_show_page_inter();
    }
  },
  methods: {
    getMiniCode() {
      this.qrCodeLoading = true;
      comApi
        .getMiniCode()
        .then(res => {
          this.qrCodeLoading = false;
          if (res.errCode == 0) {
            this.qrCode = res.data.base64_image;
          }
        })
        .catch(err => {
          this.qrCodeLoading = false;
          throw new Error(err);
        });
    },
    checkIsBind() {
      this.checkBindTimer = setTimeout(() => {
        let load_mini_code = false;
        this.checkIsBindParent(load_mini_code);
      }, 10 * 1000);
    },
    checkIsBindParent(load_mini_code = true) {
      clearInterval(this.checkBindTimer);
      this.checkBindTimer = null;
      comApi
        .isBindParent()
        .then(res => {
          if (res.errCode == 0) {
            if (res.data.status == false) {
              this.showBindParent = true;
              if (load_mini_code === true) {
                this.getMiniCode();
              }
              this.checkIsBind();
            } else {
              if (this.showBindParent == true) {
                this.showBindParent = false;
                this.$message.success("账号激活成功！");
              } else {
                this.showBindParent = false;
              }
            }
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    jude_show_page_inter() {
      this.showBindParent = false;
      if (
        this.$cookies.get("user_type") == 2 &&
        this.org_code() == "jp" &&
        this.$route.name != "login" &&
        this.$route.name != "register"
      ) {
        this.checkIsBindParent();
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
